import { createAsyncThunk } from "@reduxjs/toolkit";
import { ChatService } from "@root/services";
import {
  DO_QUERY_ACTION,
  EXPORT_CHAT,
  GET_GOVT_RULES_API_ACTION,
  GET_IMAGES_DESC_API_ACTION,
  GET_REAL_ACCIDENTS_API_ACTION,
  MULTI_AI_CHAT_ACTION,
  RISKCHECK_API_ACTION,
} from "@root/store/action-types/chatActions";
import { getBaseUrl } from "@root/store/selectors/features";
import { isFuncType } from "@root/utils/helpers";

const chatServices = new ChatService();

export const doQuery: any = createAsyncThunk(
  DO_QUERY_ACTION,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError, payload, PID, useChatAPI } = requestPayload;

    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const { data } = await chatServices.sendInput(
        baseUrl,
        payload,
        useChatAPI,
        PID
      );
      console.log(data);
      if (isFuncType(onSuccess)) {
        onSuccess(data?.data);
      }
      return thunkAPI.fulfillWithValue(data);
    } catch (error) {
      if (isFuncType(onError)) {
        onError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const doQueryProject: any = createAsyncThunk(
  DO_QUERY_ACTION,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError, payload, PID, useChatAPI } = requestPayload;

    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const { data } = await chatServices.sendInputProject(
        baseUrl,
        payload,
        useChatAPI,
        PID
      );
      if (isFuncType(onSuccess)) {
        onSuccess(data?.data);
      }
      return thunkAPI.fulfillWithValue(data);
    } catch (error) {
      if (isFuncType(onError)) {
        onError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const doQueryMultiDoc: any = createAsyncThunk(
  DO_QUERY_ACTION,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError, payload, PID, useChatAPI } = requestPayload;

    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const { data } = await chatServices.sendInputMultiDoc(
        baseUrl,
        payload,
        useChatAPI,
        PID
      );
      if (isFuncType(onSuccess)) {
        onSuccess(data?.data);
      }
      return thunkAPI.fulfillWithValue(data);
    } catch (error) {
      if (isFuncType(onError)) {
        onError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const doQueryDrawingAnalysis: any = createAsyncThunk(
  DO_QUERY_ACTION,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError, payload, PID, useChatAPI } = requestPayload;

    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const { data } = await chatServices.sendInputDrawingAnalysis(
        baseUrl,
        payload,
        useChatAPI,
        PID
      );
      if (isFuncType(onSuccess)) {
        onSuccess(data?.data);
      }
      return thunkAPI.fulfillWithValue(data);
    } catch (error) {
      if (isFuncType(onError)) {
        onError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const doQueryKCS: any = createAsyncThunk(
  DO_QUERY_ACTION,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError, payload } = requestPayload;

    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const { data } = await chatServices.sendInputKCS(baseUrl, payload);
      if (isFuncType(onSuccess)) {
        onSuccess(data?.data);
      }
      return thunkAPI.fulfillWithValue(data);
    } catch (error) {
      if (isFuncType(onError)) {
        onError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const exportChat: any = createAsyncThunk(
  EXPORT_CHAT,
  async (requestPayload: any, thunkAPI: any) => {
    const { onError, onSuccess, apiParams } = requestPayload;

    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const { data } = await chatServices.getDownloadChat(baseUrl, apiParams);
      if (isFuncType(onSuccess)) {
        onSuccess(data);
      }
      return thunkAPI.fulfillWithValue(data);
    } catch (error) {
      if (isFuncType(onError)) {
        onError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const riskCheckerCall: any = createAsyncThunk(
  RISKCHECK_API_ACTION,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError, payload } = requestPayload;

    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const { data } = await chatServices.riskCheckerCall(baseUrl, payload);
      if (isFuncType(onSuccess)) {
        onSuccess(data?.data);
      }
      return thunkAPI.fulfillWithValue(data);
    } catch (error) {
      if (isFuncType(onError)) {
        onError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const userGetImagesDesc: any = createAsyncThunk(
  GET_IMAGES_DESC_API_ACTION,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError, payload } = requestPayload;

    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const { data } = await chatServices.getImagesDesc(baseUrl, payload);
      if (isFuncType(onSuccess)) {
        onSuccess(data?.data);
      }
      return thunkAPI.fulfillWithValue(data);
    } catch (error) {
      if (isFuncType(onError)) {
        onError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getGovtRules: any = createAsyncThunk(
  GET_GOVT_RULES_API_ACTION,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError, payload } = requestPayload;

    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const { data } = await chatServices.get_govt_rules(baseUrl, payload);
      if (isFuncType(onSuccess)) {
        onSuccess(data?.data);
      }
      return thunkAPI.fulfillWithValue(data);
    } catch (error) {
      if (isFuncType(onError)) {
        onError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getRealAccidents: any = createAsyncThunk(
  GET_REAL_ACCIDENTS_API_ACTION,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError, payload } = requestPayload;

    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const { data } = await chatServices.get_real_accidents(baseUrl, payload);
      if (isFuncType(onSuccess)) {
        onSuccess(data?.data);
      }
      return thunkAPI.fulfillWithValue(data);
    } catch (error) {
      if (isFuncType(onError)) {
        onError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const doMultiAIChat: any = createAsyncThunk(
  MULTI_AI_CHAT_ACTION,
  async (requestPayload: any, thunkAPI: any) => {
    const {
      onSuccess,
      onError,
      query,
      type,
      chatType,
      chatId,
      threadId,
      isPolling,
    } = requestPayload;

    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const { data } = await chatServices.sendMultiAIChat(baseUrl, {
        query,
        type,
        chatType,
        chatId,
        threadId,
      });

      if (isFuncType(onSuccess)) {
        onSuccess(data?.data);
      }
      return thunkAPI.fulfillWithValue(data);
    } catch (error) {
      if (isFuncType(onError)) {
        onError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);
